import React, { useEffect, useRef, useState } from "react";
import {
  Box,
  Grid,
  Card,
  CardBody,
  CardHeader,
  Image,
  Text,
  ResponsiveContext,
  Layer,
} from "grommet";
import { PlayFill, Close } from "grommet-icons";

import dashboard from "../../assets/dashboard.png";
import users from "../../assets/users.png";
import assessments from "../../assets/assessments.png";
import recommendations from "../../assets/skill-summary.png";

const tutorials = [
  {
    id: 1,
    title: "Getting started with HPE Digital Skill Advisor",
    thumbnail: dashboard,
    videoUrl:
      "https://sgalitestoragepublic.blob.core.windows.net/videos/Getting%20started%20with%20HPE%20Skill%20Advisor.mp4",
  },
  {
    id: 2,
    title: "Inviting and Managing Users",
    thumbnail: users,
    videoUrl:
      "https://sgalitestoragepublic.blob.core.windows.net/videos/Inviting%20and%20Managing%20users.mp4",
  },
  {
    id: 3,
    title: "Creating and Managing Assessments",
    thumbnail: assessments,
    videoUrl:
      "https://sgalitestoragepublic.blob.core.windows.net/videos/Creating%20and%20Managing%20assessment.mp4",
  },
  {
    id: 4,
    title: "Viewing the course recommendations",
    thumbnail: recommendations,
    videoUrl:
      "https://sgalitestoragepublic.blob.core.windows.net/videos/Viewing%20course%20recommendations.mp4",
  },
];

const VideoTutorialsGrid = () => {
  const size = React.useContext(ResponsiveContext);
  const [selectedTutorial, setSelectedTutorial] = useState(null);
  const videoRef = useRef(null);

  const columns = size === "small" ? ["auto"] : ["flex", "flex"];
  const rows =
    size === "small" ? ["flex", "flex", "flex", "flex"] : ["flex", "flex"];

  useEffect(() => {
    if (selectedTutorial && videoRef.current) {
      videoRef.current.load(); // Ensure the video loads properly
    }
  }, [selectedTutorial]);

  return (
    <Box>
      <Grid columns={columns} rows={rows} gap="medium" responsive>
        {tutorials.map((tutorial) => (
          <Card
            key={tutorial.id}
            background="light-1"
            elevation="small"
            onClick={() => setSelectedTutorial(tutorial)}
            hoverIndicator
            style={{ cursor: "pointer" }}
          >
            <CardHeader pad={{ horizontal: "small", vertical: "small" }}>
              <Box direction="row" align="center" gap="small">
                <PlayFill color="brand" />
                <Text weight="bold">{tutorial.title}</Text>
              </Box>
            </CardHeader>
            <CardBody pad="small">
              <Image
                fit="cover"
                src={tutorial.thumbnail}
                alt={`${tutorial.title} Thumbnail`}
                style={{ height: "200px", width: "100%" }}
              />
            </CardBody>
          </Card>
        ))}
      </Grid>

      {/* Video Modal */}
      {selectedTutorial && (
        <Layer
          onEsc={() => setSelectedTutorial(null)}
          onClickOutside={() => setSelectedTutorial(null)}
          responsive
          modal
        >
          <Box pad="medium" width="large" background="white" round="small">
            <Box direction="row" justify="between" align="center">
              <Text size="large" weight="bold">
                Watch Video - {selectedTutorial.title}
              </Text>
              <Close
                onClick={() => setSelectedTutorial(null)}
                style={{ cursor: "pointer" }}
              />
            </Box>
            <Box margin={{ top: "medium" }} align="center">
              {/* Adding a key to force re-mounting the video element on selection */}
              <video
                key={selectedTutorial.videoUrl}
                ref={videoRef}
                width="100%"
                height="315"
                controls
                autoPlay
                muted
                playsInline
              >
                <source src={selectedTutorial.videoUrl} type="video/mp4" />
                Your browser does not support the video tag.
              </video>
            </Box>
          </Box>
        </Layer>
      )}
    </Box>
  );
};

export default VideoTutorialsGrid;
